import { Box } from '@mui/material';
import { useState } from 'react';
import DashboardContent from '../../components/dashboard/DashboardContent';
import Header from '../../components/dashboard/Header';
import SideDrawer from '../../components/dashboard/SideDrawer';

const ClientDashboardPage = () => {
  const [sidebarOpen, setSidebarOpen] = useState(true);
  const toggleSidebar = () => setSidebarOpen((open) => !open);

  return (
    <Box sx={{ display: 'flex' }}>
      <Header onToggleSidebar={toggleSidebar} open={sidebarOpen} />
      <SideDrawer open={sidebarOpen} />
      <Box component="main" sx={{ flexGrow: 1 }}>
        <DashboardContent />
      </Box>
    </Box>
  );
};

export default ClientDashboardPage; 